import CreatableSelect from "@/Components/Select/CreatableSelect";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import useCategoryHook from "@/shared/hooks/useCategoryHook";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";

interface MenuFastLabelProps extends ModalProps {}

const MenuFastLabel = ({ onExit, ...props }: MenuFastLabelProps) => {
  const { t } = useTranslation();
  const [tags, setTags] = useState([]);
  const [{ parentId }] = useModalMeta();
  const { productPatch } = useCategoryHook();
  const setModal = useSetModal();

  const handleSubmit = (e) => {
    productPatch.mutateAsync(
      {
        data: {
          label: tags.map((tag) => tag.value),
          method: e.target.id,
        },
        categoryId: parentId,
        type: "labels",
      },
      { onSuccess: () => setModal("", {}) }
    );
  };

  return (
    <Modal {...props} onExit={onExit}>
      <ModalTitle>{t("addLabel")}</ModalTitle>

      <div className="mt-4 flex flex-col gap-24">
        <CreatableSelect
          closeMenuOnSelect={false}
          label={t("tags")}
          isMulti
          name="tag"
          menuPortalTarget={document.getElementById("root")}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 1000000 }),
          }}
          placeholder={`${t("tags")}...`}
          value={tags}
          noOptionsMessage={() => tags?.length >= 3 && null}
          promptTextCreator={() => tags?.length >= 3 && null}
          isValidNewOption={() => (tags?.length >= 3 ? false : true)}
          formatCreateLabel={() => `${t("create")} ""`}
          onChange={(v) => setTags(v)}
          optionLabel
        />

        <div className="flex gap-4">
          <Button
            isDisabled={Boolean(tags.length) === false}
            isPending={productPatch.isPending}
            style={{ width: "50%" }}
            variant={Boolean(tags.length) !== false ? "danger" : "default"}
            id="remove"
            onClick={handleSubmit}
          >
            {t("menu.remove")}
          </Button>
          <Button
            isDisabled={Boolean(tags.length) === false}
            isPending={productPatch.isPending}
            style={{ width: "50%" }}
            id="add"
            onClick={handleSubmit}
          >
            {t("menu.add")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MenuFastLabel;
